import { useState, useEffect, useContext, memo } from 'react'
import { useLocation, Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import QRCode from "react-qr-code";

import { AppContext } from "../../Context";

import { IoMdArrowDropdown, IoMdArrowDropright  } from "react-icons/io";
import { SlEarphonesAlt } from "react-icons/sl";
import { FaSearch } from "react-icons/fa";
import { MdOutlineShoppingCart, MdNotificationsNone, MdHistory, MdSettings, MdLogout } from "react-icons/md";
import { FaRegUser } from "react-icons/fa6";
import { GiHamburgerMenu } from "react-icons/gi";


import Fetch from "../inc/Fetch";
import { Img, Tasks, VideoPlayer } from "../components/Elements";
import './css/Header.css'

export default function Header({ title, menuData }) {
    
    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();

    const {cartData, user, siteMenu, siteData} = useContext(AppContext); 
	const [cart, setcart] = cartData;
    const [userinfo, setuserinfo] = user;
    const [site_menu, setsite_menu] = siteMenu;
    const [siteInfo, setsiteInfo] = siteData;

    const [menu, setmenu] = useState(false);
    const [sticky, setsticky] = useState("none");
    const [openCart, setopenCart] = useState(false);
    const [loader, setloader] = useState(false);
    const [openMobileMenu, setopenMobileMenu] = useState(false);
    const [openUserMenu, setopenUserMenu] = useState(false);

    function handleNavigation(e) {

        if (e?.target?.scrollTop >= 100) {
            setsticky("sticky");
        } else {
            setsticky("none");
        }
        
    }

    async function logout() {
        setloader(true);
        await Fetch("logout");
        setuserinfo({});

        setloader(false);
        
    }

    function UserLinks({ opt }) {

        return (
            <>
                {!userinfo?._id ?
                    <>
                        {!opt ? 
                        <Link to='/login' state={{ previousLocation: location }} className='all sp'>
                            <FaRegUser />
                            <b>{t("login")}</b>
                        </Link>
                        :false}
                    </>
                :
                    <>
                    {userinfo?.name && 
                        <div onClick={() => setopenUserMenu(p => !p)} className={`userSection ${openUserMenu ? 'openNow' : "static"}`}>
                            <Img  src={userinfo?.img} load={true}/>
                            <label>
                                <b>{userinfo?.name}</b>
                                {userinfo?.company?.name && <p>{userinfo?.company?.name}</p>}
                            </label>

                            <nav>
                                <ul>
                                    <Link to='/history'><MdHistory />{t("user_orders_history")}</Link>
                                    <Link to='/account'><MdSettings />{t("user_account_info")}</Link>
                                    {/* <Link><MdSettings />{t("user_account_settings")}</Link> */}
                                    
                                    <Link onClick={logout}><MdLogout />{t("logout")}</Link>
                                </ul>
                                
                            </nav>
                        </div>
                    }
                    </>
                }
            </>

        );
    }

    useEffect(() => {

        if (window.location?.pathname == "/cart") {
            document.body.classList.add('cart-open');
        } else {
            document.body.classList.remove('cart-open');
        }
        
    }, [location]);

    useEffect(() => {

        let scrDiv = document.getElementById('mainBodyData'); 
        
        scrDiv.addEventListener("scroll", handleNavigation, false);

        return () => {
            scrDiv.removeEventListener("scroll", handleNavigation, false);
        };
    }, []);

    
    
    return (
        <>  
            {/* <div style={{padding:10}}>
                <QRCode size="950" level="H" value="https://www.instagram.com/katias.art?igsh=OHpjcnN1ZnJvY3Bl" />
            </div> */}


            <header >
                <div className='logoBox'>

                    <div className="mainWidth">

                        <div className='f1'>
                            <Link to='/'><Img className="logo" src={siteInfo?.website?.logo[0]} load={true} /></Link>

                            {siteInfo?.website?.slogan_title && <div className='phoneNumberBox'>
                                <p>
                                    <div>
                                        <span>
                                            {siteInfo?.website?.slogan_title}
                                        </span>

                                        <b style={{display:"block"}}>{siteInfo?.website?.slogan_short}</b>
                                    </div>
                                    
                                    
                                </p>
                                
                                
                            </div>}
                        </div>

                        <div className='f2'>
                            {UserLinks({ opt: false })}

                            <Link to='/Search' className='all'>
                                <FaSearch />
                                <b>{t("search")}</b>
                            </Link>
                            <Link to='/cart' state={{ previousLocation: location }} className='all'>
                                {cart?.length ? <span>{cart?.length}</span>: false}
                                <MdOutlineShoppingCart />
                                <b>{t("cart")}</b>
                            </Link>
                            <Link onClick={() => setopenMobileMenu(p => !p)} className='all mobile_hide'>
                                <GiHamburgerMenu />
                                <b>{t("header_mobile_menu")}</b>
                            </Link>

                        </div>


                    </div>
                    
                </div>

            </header>
            <div className={`menuBox ${sticky} ${openMobileMenu ? "menuOpen" : ""}`}>
                <div className="mainWidth">
                    
                    <nav className={menu ? 'open' : 'closed'}>
                        <li className={`parent ${location?.pathname == "/" && "selected"}`}><Link to="/">{t("home")}</Link></li>

                        {site_menu?.map((v, k) => {

                            let selected = "";
                            let linktype = "_self";
                            if (v?.link_type?.val ) {
                                linktype = v?.data?.link_type?.val;
                            }

                            let linkData = `/cat/${v?.data?.val}`;
                            if (v?.type?.val == "contents") {
                                linkData = `/content/${v?.data?.val}`;
                            }
                            if (v?.type?.val == "link") {
                                linkData = v?.data?.link;
                            }

                            if (location?.pathname.indexOf(v?._id) > -1 || location?.pathname.indexOf(linkData) > -1) {
                                selected = "selected";
                            }

                            if (v?.childs?.length) {

                                return (
                                    <li key={k} className={`parent ${selected}`}>
                                        <Link target={linktype} to={linkData}>{v?.name}<IoMdArrowDropdown /></Link>
                                        <ul>
                                            <div>
                                                {v?.childs?.map((v2, k2) => {

                                                    let linktype2 = "_self";
                                                    if (v2?.data?.link_type?.val ) {
                                                        linktype2 = v2?.data?.link_type?.val;
                                                    }

                                                    let slinkData = `/cat/${v2?.data?.val}`;
                                                    if (v2?.type?.val == "contents") {
                                                        slinkData = `/content/${v2?.data?.val}`;
                                                    }

                                                    if (v2?.type?.val == "link") {
                                                        slinkData = v2?.data?.link;
                                                    }

                                                    return(
                                                        <Link key={k2} target={linktype2} to={slinkData}><IoMdArrowDropright  /> {v2?.name}</Link>
                                                    );
                                                })}
                                            </div>
                                        </ul>
                                    </li>
                                );
                            } else {

                                
                                return (
                                    <li className={`parent ${selected}`}><Link target={linktype} to={linkData}>{v?.name}</Link></li>
                                );
                            }
                            
                        })}
                        
                    </nav>
                    
                    <div className='leftMenuStick'>

                        {UserLinks({ opt: true })}
                        <Link to='/cart' state={{ previousLocation: location }} className='stickyCart'>
                            {cart?.length ? <span></span>: false}
                            <MdOutlineShoppingCart />
                        </Link>
                    </div>
                    
                    
                </div>
            </div>
            

            {location?.pathname != "/Search" && 
            <div className={`effect ${location?.pathname == "/" ? "main" : "inside"}`}>
                <div className='blend'></div>
                
                
                <>
                    {location?.pathname == "/" && <div className='textBox'>
                        <h2>{siteInfo?.website?.main_content?.subtitle}</h2>
                        <h1>{siteInfo?.website?.main_content?.title}</h1>
                        <h3>{siteInfo?.website?.main_content?.short}</h3>

                        <Link to={`/content/${siteInfo?.website?.main_content?._id}`} className='btn'>{t("more")}...</Link>
                    </div>}

                    {title && 
                        <div className='textBox'>
                            <h2>{siteInfo?.website?.main_content?.subtitle}</h2>
                            <h1>{siteInfo?.website?.main_content?.title}</h1>
                        </div>
                    }
                </>
                

                <VideoPlayer src={siteInfo?.website?.effect[0]} className="backgroundVideo" />
                {/* <video src={siteInfo?.website?.effect[0]} className="backgroundVideo" playsInline muted autoPlay loop></video> */}

            </div>}
            

        

        </>
    )
}
